import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from 'react-router-dom';
import config from "../../../config";
import { Col, Container, Row } from "react-bootstrap";
import CashoutMod from "../../../components/Modals/CashoutMod"
import { GET_ADMIN_BY_ID, VENDOR_PAYOUT, VENDOR_STRIPE_CONNECT, VENDOR_STRIPE_CONNECT_RETURN, VENDOR_STRIPE_DISCONNECT } from "../../../services/ApiCalls";
import { toast } from "react-toastify";
const Wallet = () => {
    const [searchParams] = useSearchParams();
    const vendorId = searchParams.get('id');
    const [accountDetails, setAccountDetails] = useState({});
    const user = localStorage.getItem("auth") && JSON.parse(localStorage.getItem("auth"));
    const [showModal, setShowModal] = useState(false)
    const [walletDetails, setwalletDetails] = useState({});
    const [stripeAction, setStripeAction] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        if (user && user.accountDetails) {
            setAccountDetails(user?.accountDetails[0])
            setwalletDetails(user?.walletDetails)
        }
        returnHanldeStripe()
    }, [stripeAction])

    const returnHanldeStripe = async () => {
        if (vendorId && !user?.stripeConnectStatus) {
            const res = await VENDOR_STRIPE_CONNECT_RETURN(vendorId);
            if (res?.data?.status === "success") {
                toast.success(res?.data?.message);
                await getDetail()
                // window.location.href = window.location.href.replaceAll(`?id=${vendorId}`, '');
                setStripeAction(true)
            } else {
                toast.error(res?.data?.message);
            }
        }
    }
    const handleStripeDisConnect = async () => {
        const res = await VENDOR_STRIPE_DISCONNECT({});

        if (res?.data?.status === "success") {
            toast.success(res?.data?.message);
            await getDetail()
            setStripeAction(true)
        } else {
            toast.error(res?.data?.message);
        }
    }


    const getDetail = async () => {
        try {
            const id = localStorage.getItem("_id");
            const res = await GET_ADMIN_BY_ID(id);
            if (res?.data?.status === "success") {
                localStorage.setItem("auth", JSON.stringify(res?.data?.data))
            } else {
                toast.error(res?.data?.message);
            }
        } catch (error) {
            toast.error("something went wrong");
        }
    };

    const handleStripeConnect = async () => {
        const baseUrl = window.location.origin + window.location.pathname;
        const response = await VENDOR_STRIPE_CONNECT({ _id: user?._id, returnUrl: `${baseUrl}?id=${user?._id}`, refreshUrl: `${baseUrl}?id=${user?._id}` });
        if (response?.data?.data?.url) {
            window.location.href = response?.data?.data?.url;
        } else {
            toast.error("Failed to connect stripe");
        }
    }

    const handleVendorPayout = async (type) => {
        setLoader(true);
        const res = await VENDOR_PAYOUT(type);

        if (res?.data?.status === "success") {
            toast.success(res?.data?.message);
            await getDetail()
            setStripeAction(true)
            setLoader(false);

        } else {
            toast.error(res?.data?.message);
            setLoader(false);

        }
    }
    return (
        <>
            <CashoutMod show={showModal} onHide={setShowModal} handleVendorPayout={handleVendorPayout} setLoader={setLoader} loader={loader} />
            <section className="Service position-relative py-3">
                <Container>
                    <Row>
                        <Col lg={6} md={6} sm={12} className="my-2">
                            <div className="WalletHeader cardCstm border rounded px-3 py-2 text-center py-5">
                                <div className="walletCash text-center">
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24"><path fill="#c11111" d="M14.356 2.595a.25.25 0 0 1 .361-.032l.922.812L12.739 7h1.92l2.106-2.632l1.652 1.457a.25.25 0 0 1 .026.348l-.69.827h1.944a1.75 1.75 0 0 0-.288-2.3l-3.7-3.263a1.75 1.75 0 0 0-2.531.23L8.976 7h1.91zM5.25 6.5a.75.75 0 0 0 0 1.5h13a3.25 3.25 0 0 1 3.25 3.25v6.5A3.25 3.25 0 0 1 18.25 21h-12A3.25 3.25 0 0 1 3 17.75V7.25A2.25 2.25 0 0 1 5.25 5h4.32L8.378 6.5zm10.25 8.25c0 .414.336.75.75.75h2a.75.75 0 0 0 0-1.5h-2a.75.75 0 0 0-.75.75" /></svg>
                                    </span>
                                    <div className="my-3">
                                        <h5>Total Balance</h5>
                                        <h6 className="classRed">$ {walletDetails?.balance?.toFixed(2) || 0.00}</h6>
                                    </div>
                                </div>
                                <button className="mt-4 d-inline-flex align-items-center justify-content-center commonBtn btn btn-primary" onClick={() => {
                                    setShowModal(true)
                                }}>
                                    Cash Out
                                </button>
                            </div>
                        </Col>

                        <Col lg={6} md={6} sm={12} className="my-2">
                            <div className="WalletDetail cardCstm border rounded px-3 py-2">

                                <div className="dWalletDetsList">
                                    <ul>
                                        <li>
                                            <p>Account Number : </p>
                                            <p>{user?.stripeConnectStatus ? `xxxx xxxx xxxx ${accountDetails?.accountNumber}` : '--'}</p>
                                        </li>
                                        <li>
                                            <p>Account Holder Name : </p>
                                            <p>{user?.stripeConnectStatus ? accountDetails?.accountHolderName : '--'}</p>
                                        </li>
                                        <li>
                                            <p>Bank Name : </p>
                                            <p>{user?.stripeConnectStatus ? accountDetails?.bankName : '--'}</p>
                                        </li>
                                        <li>
                                            <p>Routing Number : </p>
                                            <p>{user?.stripeConnectStatus ? accountDetails?.routingNumber : '--'}</p>
                                        </li>
                                    </ul>
                                </div>



                                <div className="mt-4 d-flex align-items-center justify-content-between">
                                    <p className="connectStatus m-0" style={{ paddingLeft: "10px" }}>{user?.stripeConnectStatus && 'Connected'}</p>
                                    {user?.stripeConnectStatus ?
                                        <button className="d-inline-flex align-items-center justify-content-center commonBtn btn btn-primary" onClick={handleStripeDisConnect}>
                                            Disconnect
                                        </button>
                                        : <button className="d-inline-flex align-items-center justify-content-center commonBtn btn btn-primary" onClick={handleStripeConnect}>
                                            Connect
                                        </button>
                                    }

                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Wallet